<template>
  <header>
    <!-- Desktop Header -->
    <div class="header-desktop-youtube">
      <b-container fluid class="h-100">
        <b-row :class="isMobile? 'addShadow':''">
          <b-col id="Start" class="header-item">
            <button v-if="!isMobile">
              <img
                class="yt-icon"
                src="../../assets/img/Youtube/menu.png"
                alt="MENU"
              />
            </button>
            <button id="btnLogo" @click="goBackToHomepage">
              <img
                id="logo"
                src="../../assets/img/Youtube/yt_logo_rgb_light.png"
                alt="Youtube-Logo"
              />
            </button>
          </b-col>
          <b-col id="Center" class="header-item" v-if="windowWidth>668 && !isMobile" >
            <div class="search-container">
              <div class="search-input-container">
                <input
                  id="search-input"
                  type="text"
                  v-model="searchWord"
                  :placeholder="$t('page.youtube.youtubeSearch')"
                  @focus="onSearchFocus"
                  @blur="onSearchBlur"
                  :class="{ 'search-focused': isSearchFocused }"
                />
                <div class="search-icon-container">
                  <button class="search-btn" type="button">
                    <svg viewBox="0 0 24 24" class="search-icon">
                      <path d="M20.87,20.17l-5.59-5.59C16.35,13.35,17,11.75,17,10A7,7,0,1,0,10,17c1.75,0,3.35-.65,4.58-1.71l5.59,5.59ZM10,15A5,5,0,1,1,15,10,5,5,0,0,1,10,15Z"/>
                    </svg>
                  </button>
                </div>
              </div>
              <button class="voice-search-btn" v-if="windowWidth > 800">
                <svg viewBox="0 0 24 24" class="voice-icon">
                  <path d="M12,2A3,3,0,0,1,15,5V11a3,3,0,0,1-6,0V5A3,3,0,0,1,12,2ZM19,11a1,1,0,0,0-2,0,5,5,0,0,1-10,0,1,1,0,0,0-2,0,7,7,0,0,0,6,6.92V20H8.5a1,1,0,0,0,0,2h7a1,1,0,0,0,0-2H13V17.92A7,7,0,0,0,19,11Z"/>
                </svg>
              </button>
            </div>
          </b-col>
          <b-col id="End" class="header-item" v-show="windowWidth>200">
            <button v-show="windowWidth>300 && !isMobile">
              <img
                class="yt-icon"
                src="../../assets/img/Youtube/createVideo.png"
                alt="Create Video"
              />
            </button>
            <button  v-show="windowWidth>260 && !isMobile">
              <img
                class="yt-icon"
                src="../../assets/img/Youtube/notification.png"
                alt="Notifications"
              />
            </button>
                <button v-if="isMobile" id="seachIcon-mobile">
                  <img
                    src="../../assets/img/Youtube/search_icon.png"
                    alt=""
                    class="yt-icon"
                  />
                </button>
            <button>
              <img
                class="yt-icon"
                src="../../assets/img/Youtube/userPhoto.png"
                alt="User"
              />
            </button>
          </b-col>
        </b-row>
        <b-row v-if="this.isMobile">
          <!-- <SubHeader /> -->
        </b-row>
      </b-container>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
// import SubHeader from "./SubHeader.vue";
export default {
  props:{
    isMobile:{
      type: Boolean,
      default:false,
    }
  },
  data() {
    return {
      searchWord: "",
      windowWidth: window.innerWidth,
      isSearchFocused: false
    };
  },
  components:{
    // SubHeader,
  },
  computed:{
    ...mapGetters("youtube", {
      surveyStep: "getSurveyStep",
    }),
  },
  methods: {
    goBackToHomepage() {
      if(this.surveyStep==="stimulus")return;
      window.scrollTo(0,0)
      this.$store.commit("youtube/SET_VIDEO_SELECTED", "");
      this.$store.commit("youtube/SET_VIDEO_SELECTED_INDEX", -1);
      this.$store.commit("youtube/SET_SELECTED_POST", null);
    },
    onResize(){
      this.windowWidth = window.innerWidth;
    },
    onSearchFocus() {
      this.isSearchFocused = true;
    },
    onSearchBlur() {
      this.isSearchFocused = false;
    }
  },
  created() {
    this.$store.commit("utilities/SET_EMOTIVA_HEADER", false);
  },
  mounted(){
    this.$nextTick(()=>{
      window.addEventListener("resize",this.onResize);
    })
  },
  beforeDestroy(){
    window.removeEventListener("resize",this.onResize);
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/youtube-styles.scss";

.header-desktop-youtube {
  width: 100%;
  height: 60px;
  display: flex;
  background-color: #fff;
  
  button {
    border: none;
    background-color: transparent;
    padding: 8px;
    margin: 0px;
    cursor: pointer;
    
    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
      border-radius: 50%;
    }
  }

  .yt-icon {
    height: 24px;
    width: auto;
    object-fit: fill;
  }

  #Start {
    justify-self: start;
    display: flex;
    align-items: center;
    
    #logo {
      height: 20px;
    }
    #btnLogo {
      height: $header-desktop-height;
      padding: 18px 14px 18px 16px;
      
      &:hover {
        background-color: transparent;
      }
    }
    max-width: 33%;
  }

  #Center {
    justify-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 40px;
    height: 64px;
    min-width: 100px;
    max-width: 728px;
    flex-grow: 1;

    .search-container {
      display: flex;
      align-items: center;
      max-width: 640px;
      width: 100%;
      
      .search-input-container {
        display: flex;
        flex: 1;
        height: 40px;
        position: relative;
        
        #search-input {
          width: 100%;
          height: 40px;
          border: 1px solid #ccc;
          border-right: none;
          border-radius: 40px 0 0 40px;
          padding: 0 16px;
          font-size: 16px;
          background-color: #fff;
          outline: none;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
          
          &::placeholder {
            color: #909090;
          }
          
          &:focus, &.search-focused {
            border-color: #1c62b9;
            box-shadow: inset 0 1px 2px rgba(27, 31, 35, 0.075);
          }
          
          &:hover {
            border-color: #909090;
            box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
          }
        }
        
        .search-icon-container {
          display: flex;
          align-items: center;
          
          .search-btn {
            height: 40px;
            width: 64px;
            border: 1px solid #ccc;
            border-left: none;
            border-radius: 0 40px 40px 0;
            background-color: #f8f9fa;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            transition: background-color 0.15s ease-in-out;
            
            &:hover {
              background-color: #f0f0f0;
              border-radius: 0 40px 40px 0;
            }
            
            .search-icon {
              width: 20px;
              height: 20px;
              fill: #030303;
            }
          }
        }
      }
      
      .voice-search-btn {
        margin-left: 12px;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #f8f9fa;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: background-color 0.15s ease-in-out;
        
        &:hover {
          background-color: #f0f0f0;
        }
        
        .voice-icon {
          width: 20px;
          height: 20px;
          fill: #030303;
        }
      }
    }
  }

  #End {
    margin: 9px 0px 0px 0px;
    display: flex;
    justify-self: end;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    
    button {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  @media screen and (max-width:668px) {
    #Start{
      max-width: 100%;
    }
    #End{
      max-width: 120px;
    }
  } 
  @media screen and (max-width:300px) {
    #End{
      max-width: 60px;
    }
  }
}

.header-item {
  max-height: $header-desktop-item-maxHeight;
}

#seachIcon-mobile{
  height: 30px;
  padding-bottom: 10px;
}

.main-row{
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
  margin-bottom: 5px;
}
</style>